import { module } from 'modujs';
import { shuffle } from '../utils/array';
import RailMove from './Railmove'
import gsap from 'gsap';
import { html } from '../utils/environment';

// data-module-rail="rail-1" 
// data-scroll="item" 
// data-scroll-call="trigger,Rail,rail-1"
// data-rail-speed="1" - optional
// data-rail-scroll - optional, usefull for scroll influence
// data-rail-scroll="one-way" - has scroll influence but with an ABS value, no way updates

export default class extends module {
    constructor(m) {
        super(m);

        this.speed = (typeof this.getData('speed') == 'string') ? parseFloat(this.getData('speed')) : 1;
        this.isFixed = (typeof this.getData('fixed') === 'string');
        this.shuffle = (typeof this.getData('shuffle') === 'string');
        this.paused = (typeof this.getData('paused') === 'string');
        this.scrollInfluence = this.getData('rail-scroll') != null ? (this.getData('scroll') == '' ? true : this.getData('scroll')) : false;
        this.isMobile = (typeof this.getData('desktop') === 'string') ? false : true
        this.initialHTML = this.el.outerHTML;
		this.isDraggable = (typeof this.getData('draggable') == 'string');

		this.$items = this.$('item');

        this.isFirstHit = true;

    }

    init() {
        if(window.isMobile && !this.isMobile) {
            return;
        }

        this.setClasses()
        this.createTrack()
        this.fillScreen()

        this.groupTracks()
        this.duplicateGroup()
        this.wrapGroups()

        this.railMove = new RailMove(this.el, window.isMobile ? this.speed/2 : this.speed, this.isFixed, this.paused, window.isMobile ? false : this.scrollInfluence)
        this.railMove.itemLength = this.$items.length;
		this.railMove.setContainerWidth(this.trackGroupBCR.width)

		if(this.isDraggable) {

			this.isDragging = false;
			this.draggableTouchRatio = (window.isMobile) ? 22 : 10;
			
			this.dragVelocity = {value: 0};
			this.bindMouseDown = this.mousedown.bind(this);
			this.bindMouseUp = this.mouseup.bind(this);
			this.bindMouseMove = this.mousemove.bind(this);

			if(this.getData('draggable') != '') {
				this.draggableZone = document.querySelector(this.getData('draggable'));
			} else {
				this.draggableZone = this.el;
			}

			this.draggableZone.addEventListener('mousedown',this.bindMouseDown);
			window.addEventListener('mouseup',this.bindMouseUp);
			this.draggableZone.addEventListener('mousemove',this.bindMouseMove);

			this.draggableZone.addEventListener('touchstart',this.bindMouseDown,{passive: true});
			window.addEventListener('touchend',this.bindMouseUp,{passive: true});
			this.draggableZone.addEventListener('touchmove',this.bindMouseMove,{passive: true});

			this.dragTo = gsap.quickTo(this.dragVelocity, 'value',{
				duration: 0.3,
				onUpdate: () => {
					this.railMove.velocity = this.dragVelocity.value;
				}
			});
		}
    }

    setClasses() {
        this.el.classList.add('c-rail_wrapper')
        this.children = Array.from(this.el.children)

        for(let child of this.children) {
            child.classList.add('c-rail_item', 'js-rail-item');
        }
    }

    createTrack() {
        this.track = document.createElement('div')
        this.track.classList.add('c-rail_track')
        this.el.appendChild(this.track)

        this.tracks = []
        this.tracks.push(this.track)
		
        if(this.shuffle) {			
            let shuffled = shuffle(this.children)
            
            for(let el of shuffled) {
                this.track.appendChild(el)
            }
        } else {
            for(let child of this.children) {
                this.track.appendChild(child)
            }
        }

    }

    fillScreen() {
        let ratio = window.innerWidth / this.track.getBoundingClientRect().width

        if(ratio === Infinity) {
            throw new Error('Ratio is Infinity');
        }

        for (var i = 0; i < ratio; i++) {
            let track = this.track.cloneNode(true)
            this.tracks.push(track)
            this.el.appendChild(track)
        }
    }

    groupTracks() {
        this.trackGroup = document.createElement('div')
        this.trackGroup.classList.add('c-rail_track-group')

        this.el.appendChild(this.trackGroup)

        for(let track of this.tracks)
            this.trackGroup.appendChild(track)

        this.trackGroupBCR = this.trackGroup.getBoundingClientRect()
    }

    duplicateGroup() {
        this.trackGroupClone = this.trackGroup.cloneNode(true)
        this.el.appendChild(this.trackGroupClone)
    }

    wrapGroups() {
        this.groupsWrap = document.createElement('div')
        this.groupsWrap.classList.add('js-rail-group-container')
        this.groupsWrap.classList.add('c-rail_group-container')
        this.el.append(this.groupsWrap)

        for(let group of [this.trackGroup, this.trackGroupClone])
            this.groupsWrap.append(group)

    }

	checkAutoplayVideos() {

		function callbackLoadedVideo(video) {
			video.classList.add('is-loaded');
			video.removeEventListener('canplaythrough', callbackLoadedVideo);
		}

		this.el.querySelectorAll('video').forEach(video => {
			// console.log(video.src);

			video.src = video.getAttribute('data-src');
			
			video.play();

			video.addEventListener('canplaythrough',callbackLoadedVideo(video));
		})
	}

    trigger(e) {
        if(window.isMobile && !this.isMobile) {
            return;
        }

		if(this.isFirstHit) {
			this.checkAutoplayVideos();
		}

        if(e.mode === 'enter') {
            if(this.isFirstHit) {
                this.railMove.launch();
                this.isFirstHit = false;
            } else {
                this.railMove.pause();
                this.railMove.resume();
            }
        } else {
            this.railMove.pause();
        }
    }

    launch() {
        this.railMove.launch();
    }

	mousedown(e) {
		this.isDragging = true;
		this.grab = true;
		this.now = performance.now();

		if(window.isMobile) {
			if(e.touches.length > 0) {
				this.oldGrabPos = e.touches[0].clientX;	
			}
		} else {
			this.oldGrabPos = e.clientX ;	
		}
		
		html.classList.add('is-dragging');
		this.dragTo.tween.duration(0.3);
	}

	mouseup(e) {
		if(!this.isDragging) return;
		this.grab = false;

		html.classList.remove('is-dragging');
		
		let t = this.lastDistance / this.dragVelocity.value;

		this.dragTo.tween.duration(1);
		
		this.dragTo((this.lastDistance) < 0 ? -this.speed : this.speed);

	}

	mousemove(e) {
		if(!this.isDragging) return;

		if(this.grab) {

			if(window.isMobile) {
				if(e.touches.length > 0) {
					this.grabPos = e.touches[0].clientX;	
				}
			} else {
				this.grabPos = e.clientX ;	
			}

			let d = this.grabPos - this.oldGrabPos;
			let t = performance.now() - this.now;

			if(t == 0) return;

			let v = d/t;

			this.dragTo(v * this.draggableTouchRatio);

			this.lastDistance = d;

			this.oldGrabPos = this.grabPos;
			this.now = performance.now();
		}
	}

	cosInfluence({ progress, isReversed }) {
		let relativeProgress = progress;
		if (isReversed) relativeProgress = 1 - progress;
	
	}

    destroy() {
        super.destroy();

		this.railMove.destroy();

		if(this.isDraggable) {
			this.draggableZone.removeEventListener('mousedown',this.bindMouseDown);
			this.draggableZone.removeEventListener('mouseup',this.bindMouseUp);
			this.draggableZone.removeEventListener('mousemove',this.bindMouseMove);

			this.draggableZone.removeEventListener('touchstart',this.bindMouseDown);
			this.draggableZone.removeEventListener('touchend',this.bindMouseUp);
			this.draggableZone.removeEventListener('touchmove',this.bindMouseMove);
		}
    }
}